module.exports = __webpack_public_path__ + "media/friend.487e5c99.mp3";